import React from 'react';

const CropWarning = () => {
  return (
    <div className="crop-warning">
      <img src="/images/assets/crop.png" alt="Crop-Warning" title="Crop Warning" />
      <p>Please make sure you are happy with the crop of your photos.</p>
    </div>
  );
};

export default CropWarning;
